export class GitRepository {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "integrationId",
            "baseName": "integrationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "GitProvider",
            "format": ""
        },
        {
            "name": "providerRepositoryId",
            "baseName": "providerRepositoryId",
            "type": "string",
            "format": ""
        },
        {
            "name": "fullName",
            "baseName": "fullName",
            "type": "string",
            "format": ""
        },
        {
            "name": "webUrl",
            "baseName": "webUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "_private",
            "baseName": "private",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "defaultBranch",
            "baseName": "defaultBranch",
            "type": "string",
            "format": ""
        },
        {
            "name": "defaultHeadSha",
            "baseName": "defaultHeadSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GitRepositoryStatus",
            "format": ""
        },
        {
            "name": "failureCode",
            "baseName": "failureCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GitRepository.attributeTypeMap;
    }
    constructor() {
    }
}
